import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const FieldCard = ({ field, isSelected, onSelect, onViewDetails }) => {
  const getDifficultyColor = (level) => {
    switch (level) {
      case 'easy': return 'text-green-600 bg-green-50';
      case 'medium': return 'text-amber-600 bg-amber-50';
      case 'hard': return 'text-red-600 bg-red-50';
      default: return 'text-gray-600 bg-gray-50';
    }
  };

  const getDemandColor = (level) => {
    switch (level) {
      case 'high': return 'text-green-600 bg-green-50';
      case 'medium': return 'text-blue-600 bg-blue-50';
      case 'low': return 'text-gray-600 bg-gray-50';
      default: return 'text-gray-600 bg-gray-50';
    }
  };

  return (
    <div className={`bg-white rounded-xl border-2 transition-all ${isSelected ? 'border-blue-500 shadow-lg' : 'border-gray-200 hover:border-blue-300 hover:shadow-md'} p-4 md:p-6`}>
      <div className="flex items-start gap-3 mb-4">
        <Checkbox
          checked={isSelected}
          onChange={(e) => onSelect(field?.id, e?.target?.checked)}
          className="mt-1"
        />
        <div className="flex-1 min-w-0">
          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-2">
            <h3 className="text-lg md:text-xl font-semibold text-gray-800 break-words">
              {field?.name}
            </h3>
            <div className="flex items-center gap-2 bg-blue-50 px-3 py-1 rounded-full flex-shrink-0">
              <Icon name="Target" size={16} color="#2563EB" />
              <span className="text-sm font-semibold text-blue-600 whitespace-nowrap">
                {field?.compatibilityScore}% compatible
              </span>
            </div>
          </div>
          <p className="text-sm md:text-base text-gray-600 mb-4 line-clamp-2">
            {field?.description}
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
        <div className="flex items-center gap-2 text-sm">
          <Icon name="Briefcase" size={18} color="#6B7280" />
          <span className="text-gray-700">{field?.careerProspects}</span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Icon name="TrendingUp" size={18} color="#6B7280" />
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getDemandColor(field?.marketDemand)}`}>
            {field?.marketDemand === 'high' ? 'Forte demande' : field?.marketDemand === 'medium' ? 'Demande moyenne' : 'Demande faible'}
          </span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Icon name="GraduationCap" size={18} color="#6B7280" />
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getDifficultyColor(field?.difficulty)}`}>
            {field?.difficulty === 'easy' ? 'Accessible' : field?.difficulty === 'medium' ? 'Intermédiaire' : 'Exigeant'}
          </span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Icon name="Coins" size={18} color="#6B7280" />
          <span className="text-gray-700 whitespace-nowrap">{field?.salaryRange}</span>
        </div>
      </div>
      <div className="mb-4">
        <h4 className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
          <Icon name="BookOpen" size={16} />
          Matières requises
        </h4>
        <div className="flex flex-wrap gap-2">
          {field?.requiredSubjects?.map((subject, index) => (
            <span key={index} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs">
              {subject}
            </span>
          ))}
        </div>
      </div>
      <div className="mb-4">
        <h4 className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
          <Icon name="School" size={16} />
          Établissements disponibles
        </h4>
        <p className="text-sm text-gray-600">{field?.availableInstitutions} établissements au Sénégal</p>
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <Button
          variant="default"
          iconName="Eye"
          iconPosition="left"
          onClick={() => onViewDetails(field)}
          className="flex-1"
        >
          Voir les détails
        </Button>
        <Button
          variant="outline"
          iconName="School"
          iconPosition="left"
          className="flex-1"
        >
          Voir les écoles
        </Button>
      </div>
    </div>
  );
};

export default FieldCard;